import Vue from 'vue'
import Vuex from 'vuex'
import * as m from './mutation-types'
import * as a from './action-types'
import API from './api'
import {filterZeroPrices} from './helpers'

Vue.use(Vuex)

const addOrUpdateCard = (state, card, commit) => {
  const foundIndex = state.cards.findIndex(c => c.slug === card.slug)
  if (foundIndex > -1) {
    commit(m.UPDATE_CARD, {index: foundIndex, card})
  } else {
    commit(m.ADD_CARD, card)
  }
}

export default new Vuex.Store({
  state: {
    loading: false,
    updating: false,
    cards: []
  },
  getters: {
    thereAreChangedRecordsFor: state => (card) => {
      return card.records.filter(r => r.changed).length > 0
    },
    loading: state => {
      return state.loading
    },
    updating: state => {
      return state.updating
    },
    getCardBy: (state, getters) => (slug) => {
      return state.cards.find(c => c.slug === slug)
    },
    getRecordBy: (state, getters) => (slug, id) => {
      const card = getters.getCardBy(slug)
      if (card) {
        return card.records.find(r => r.id === +id)
      }
    }
  },
  mutations: {
    [m.SET_PREVIOUS_PRICES] (state, {record, previousPrices}) {
      record.draftPrices = previousPrices
    },
    [m.START_LOADING] (state) {
      state.loading = true
    },
    [m.STOP_LOADING] (state) {
      state.loading = false
    },
    [m.START_UPDATING] (state) {
      state.updating = true
    },
    [m.STOP_UPDATING] (state) {
      state.updating = false
    },
    [m.ADD_CARD] (state, card) {
      state.cards.push(card)
    },
    [m.UPDATE_CARD] (state, {index, card}) {
      Vue.set(state.cards, index, card)
    },
    [m.ADD_DRAFT_PRICE] (state, record) {
      record.draftPrices.push({
        price: '0.00'
      })
    },
    [m.REMOVE_DRAFT_PRICE] (state, {record, index}) {
      record.draftPrices.splice(index, 1)
    },
    [m.RECORD_CHANGED] (state, record) {
      Vue.set(record, 'changed', true)
    }
  },
  actions: {
    [a.FETCH_CARD] ({commit, state}, slug) {
      API.card.getItem(slug).then(
        ({body}) => {
          addOrUpdateCard(state, body, commit)
        })
    },
    [a.UPDATE_CARD] ({commit, state}, card) {
      let data = {}
      data.records = card.records.map(r => {
        return {
          id: r.id,
          draftPrices: filterZeroPrices(r.draftPrices)
        }
      })
      commit(m.START_UPDATING)
      return API.card.updateItem(card.slug, data).then(
        ({body}) => {
          addOrUpdateCard(state, body, commit)
        }
      ).then(() => {
        commit(m.STOP_UPDATING)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js